import { useState, useEffect } from "react";
import JobInfo from "../jobInfo";
import Modal from "./modal";
import moment from "moment";
import { jobOpportunitySelector } from "../selector";
import { useDispatch, useSelector } from "react-redux";
import { getIncentiveMarkup, getMultishiftAmount, getRatePerHour, totalShiftAmountCalculation, updateBillingRate, updateJobInfoDetails } from "../action";
import { setencounterCalculation, setjobMultishiftOccurreneUpdateList } from '../slice'
import useConfiguration from "../../../hooks/useConfiguration";
import useSessionStorage from "../../../hooks/useSessionStorage";
import { guid } from '@progress/kendo-react-common';
import { OverlayTrigger, Popover } from "react-bootstrap";
import { getViewVariableRateDetails } from "./action";
import { payRateTypeObj } from "../../../helpers/data";
import { formatNumberWithCommas } from "../../../helpers/regEx";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    const { jobInfo, encounterCalculation, authUsersList, JobEncounterOccurreneUpdateList, recursionFlag, shift, location, jobShiftAmountMultishiftOccurreneUpdateList, jobMultishiftOccurreneUpdateList, rrurle, incentiveMarkup ,payRateType,payRateOccurrenceAmount} =
        useSelector(jobOpportunitySelector);
    const { viewVariableRate } = useSelector(state => state.jobDetails)
    const dispatch = useDispatch()
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem("login");
    // console.log(encounterCalculation);
    // console.log(props, '============',jobInfo);
    const [showModal, setShowModal] = useState(false);
    const [shiftamount, setShiftAmpunt] = useState(0);
    const [total, setTotal] = useState(0);
    const [billingRate, setBillingRate] = useState(0)
    const edit = (event) => {
        event.preventDefault();
        setShowModal(!showModal);
    };
    const save = (event) => {
        event.preventDefault();
        props.sumbitJobDetails(true).then(success => {
            if (success) {
                setShowModal(!showModal);
            }
        });
    };

    // useEffect(() => {
    //     if (props?.jobDateToDisplay && props?.startTime && props?.endTime) {
    //         // hh:mm:ss a
    //         let startTime = '';
    //         let endTime = '';
    //         const start = moment(props?.startTime, "hh:mm:ss").format("hh:mm:ss A")
    //         const end = moment(props?.endTime, "hh:mm:ss").format("hh:mm:ss A")
    //         const startAmPM = start.split(' ')[1];
    //         const endAmPM = end.split(' ')[1];
    //         console.log(startAmPM, endAmPM)
    //         if (startAmPM === 'PM' && endAmPM === 'AM') {
    //             startTime = moment(props?.jobDateToDisplay + ' ' + props?.startTime, "MM/DD/YYYY hh:mm:ss");
    //             endTime = moment(props?.jobDateToDisplay + ' ' + props?.endTime, "MM/DD/YYYY hh:mm:ss").add(1, 'days');
    //             //console.log('inside after -- time', startTime, endTime);
    //         } else {
    //             startTime = moment(props?.jobDateToDisplay + ' ' + props?.startTime, "MM/DD/YYYY hh:mm:ss");
    //             endTime = moment(props?.jobDateToDisplay + ' ' + props?.endTime, "MM/DD/YYYY hh:mm:ss");
    //         }
    //         // const startTime = moment(shift?.startTime?.id, "hh:mm:ss");
    //         // const endTime = moment(shift?.endTime?.id, "hh:mm:ss");
    //         const duration = moment.duration(endTime.diff(startTime));
    //         // console.log('duration', duration)
    //         if (duration?._data && (duration?._data?.hours || duration?._data?.minutes) && props?.billingrate) {
    //             // console.log('hours', duration?._data?.hours);
    //             // console.log('min', duration?._data?.minutes / 60);
    //             // console.log('totalhours', (duration?._data?.hours + (duration?._data?.minutes / 60)))
    //             const val = props?.billingrate * (duration?._data?.hours + (duration?._data?.minutes / 60));
    //             //console.log('shiftamo', val);
    //             if (val) {
    //                 setShiftAmpunt(val?.toFixed(2))
    //             }


    //         }
    //         //console.log('after -- time', startTime, endTime);
    //         // console.log('diff', duration?._data)
    //     }
    // }, [props?.billingrate, props?.startTime, props?.jobDateToDisplay, props?.endTime])


    // singleshift calculation
    useEffect(() => {
        if (shift?.date && shift?.startTime && shift?.endTime && recursionFlag?.toString() === "1") {
            let startTime = "";
            let endTime = "";
            const start = moment(shift?.startTime?.id, "hh:mm:ss").format(
                "hh:mm:ss A"
            );
            const end = moment(shift?.endTime?.id, "hh:mm:ss").format("hh:mm:ss A");
            const startAmPM = start.split(" ")[1];
            const endAmPM = end.split(" ")[1];
            // (startAmPM === "AM" && endAmPM === "AM") 
            const d1 = moment(
                shift?.date + " " + shift?.startTime?.id,
                "YYYY-MM-DD hh:mm:ss"
            )
            const d2 = moment(
                shift?.date + " " + shift?.endTime?.id,
                "YYYY-MM-DD hh:mm:ss"
            )
            // console.log(moment(
            //   shift?.date + " " + shift?.startTime?.id,
            //   "YYYY-MM-DD hh:mm:ss"
            // ));
            // console.log(moment(
            //   shift?.date + " " + shift?.endTime?.id,
            //   "YYYY-MM-DD hh:mm:ss"
            // ));
            // (startAmPM === "PM" && endAmPM === "AM")
            if (!d2.isAfter(d1)) {
                startTime = moment(
                    shift?.date + " " + shift?.startTime?.id,
                    "YYYY-MM-DD hh:mm:ss"
                );
                endTime = moment(
                    shift?.date + " " + shift?.endTime?.id,
                    "YYYY-MM-DD hh:mm:ss"
                ).add(1, "days");
            } else {
                startTime = moment(
                    shift?.date + " " + shift?.startTime?.id,
                    "YYYY-MM-DD hh:mm:ss"
                );
                endTime = moment(
                    shift?.date + " " + shift?.endTime?.id,
                    "YYYY-MM-DD hh:mm:ss"
                );
            }
            // const startTime = moment(shift?.startTime?.id, "hh:mm:ss");
            // const endTime = moment(shift?.endTime?.id, "hh:mm:ss");
            const duration = moment.duration(endTime.diff(startTime));
            if (
                duration?._data &&
                (duration?._data?.days || duration?._data?.hours || duration?._data?.minutes) &&
                jobInfo?.billingrate
            ) {
                const shiftamount =
                    jobInfo?.billingrate *
                    ((duration?._data?.days * 24) + (duration?._data?.hours + duration?._data?.minutes / 60));
                if (shiftamount) {
                    dispatch(
                        updateJobInfoDetails(
                            `${config.baseUrl}`,
                            "shiftamount",
                            shiftamount?.toFixed(2)
                        )
                    );
                }
            }
        }
    }, [shift, jobInfo?.billingrate, recursionFlag]);
    // useEffect(() => {
    //     // if (jobInfo?.jobCategory && jobInfo?.jobCategory?.id && parseInt(recursionFlag) !== 2) {
    //     if (jobInfo?.jobCategory && jobInfo?.jobCategory?.id && parseInt(recursionFlag) !== 2 && shift?.startTime?.id && shift?.endTime?.id && shift.date && location?.locationNameInfo?.id) {
    //         const params = {
    //             employerUniqueId: login.employerUniqueId,
    //             locationId: location?.locationNameInfo?.id,
    //             jobCategoryId: jobInfo?.jobCategory?.id,
    //             startTime: shift?.startTime?.id,
    //             endTime: shift?.endTime?.id,
    //             recursionFlag: recursionFlag,
    //             shiftDate: shift.date
    //         };
    //         config.baseUrl &&
    //             dispatch(getRatePerHour({ url: config.baseUrl, params }));
    //     }
    // }, [jobInfo?.jobCategory, shift.date, shift?.startTime?.id, shift?.endTime?.id, recursionFlag, location?.locationNameInfo?.id, shift?.endDate]);
    useEffect(() => {
        if (jobInfo?.shiftamount && recursionFlag?.toString() !== "2") {
            const totalval =
                (jobInfo?.incentive ? parseFloat(jobInfo?.incentive) : 0) +
                parseFloat(jobInfo?.shiftamount);
            dispatch(
                updateJobInfoDetails(
                    `${config.baseUrl}`,
                    "total",
                    Number(totalval)?.toFixed(2)
                )
            );
        }
        if (jobInfo?.incentive) {
            if (recursionFlag?.toString() === "3") {
                const incentiveVal = ""
                dispatch(
                    updateJobInfoDetails(
                        `${config.baseUrl}`,
                        "incentive",
                        incentiveVal
                    )
                )
            }
        }
    }, [jobInfo?.incentive, jobInfo?.shiftamount, recursionFlag]);
    //   end single shift calculation

    // console.log({rrurle});
    // mulishift calculation
    useEffect(() => {
        if (
            !jobMultishiftOccurreneUpdateList.length &&
            rrurle &&
            recursionFlag?.toString() === '3' && shift.startTime?.name && shift.endTime?.name && shift.date
        ) {
            let shiftStartDate = shift.date ;
            let shiftEndDdate = shift.date;
            const startTime = moment(shift.startTime?.id, 'hh:mm');
            const endTime = moment(shift.endTime?.id, 'hh:mm');
            const InMinutes = moment.duration(endTime.diff(startTime)).asMinutes();
            if(InMinutes <= 0){
              shiftEndDdate =  moment(shift.date).add(1,'day').format('YYYY-MM-DD');
            } 
            const startDateFormat = moment(
              shiftStartDate + ' ' + shift.startTime.name,
              'YYYY-MM-DD H:mm A'
            );
            const endDateFormat = moment(
              shiftEndDdate + ' ' + shift.endTime.name,
              'YYYY-MM-DD H:mm A'
            );

            const calenderRequestBody = {
                TaskID: guid(),
                ownerID: guid(),
                Title: 'Shift Info',
                Description: '',
                StartTimezone: null,
                Start: new Date(startDateFormat),
                End: new Date(endDateFormat),
                EndTimezone: null,
                RecurrenceRule: rrurle,
                RecurrenceID: null,
                RecurrenceException: [],
                isAllDay: false,
                locationId: location.locationNameInfo?.id,
                jobsContactsList: location.contactPersons.map(item => item.id),
                jobsApproversList: location.approvalUsers.map(item => item.id),
                billingrate: jobInfo?.billingrate ? jobInfo?.billingrate : '',
                shiftLength: shift.preferedShift?.id ? shift.preferedShift?.id : '',
                editDay: false,
                payRateOccurrenceAmount: (+payRateType === payRateTypeObj.manualCal) ? payRateOccurrenceAmount : null
            };
            dispatch(
                setjobMultishiftOccurreneUpdateList(
                    JSON.parse(JSON.stringify([calenderRequestBody]))
                )
            );
        }
    }, [recursionFlag?.toString() === '3', rrurle, shift.startTime?.name, shift.endTime?.name, shift?.date, shift?.endDate, location.locationNameInfo?.id,payRateOccurrenceAmount])

    // useEffect(() => {
    //     // console.log({jobShiftAmountMultishiftOccurreneUpdateList, jobMultishiftOccurreneUpdateList});
    //     if ((parseInt(jobInfo?.billingRateParam)) && (jobShiftAmountMultishiftOccurreneUpdateList.length || jobMultishiftOccurreneUpdateList.length) && recursionFlag?.toString() === '3' && shift?.date && shift?.endDate) {
    //         const params = {
    //             ratePerHour: jobInfo?.ratePerHour,
    //             hourlyBillingRate: jobInfo?.billingRateParam,
    //             jobDate: shift?.date,
    //             jobEndDate: shift?.endDate,
    //             jobCategoryId: jobInfo?.jobCategory?.id
    //         };
    //         config.baseUrl &&
    //             dispatch(getMultishiftAmount({ url: config.baseUrl, params, shiftAmountMultishiftOccurrence: jobMultishiftOccurreneUpdateList.length ? jobMultishiftOccurreneUpdateList : jobShiftAmountMultishiftOccurreneUpdateList }));
    //     }
    // }, [jobInfo?.billingRateParam, jobMultishiftOccurreneUpdateList, jobInfo?.jobCategory?.id])


    // encounter calculation
    useEffect(() => {
        // console.log('trgger---------')
        //console.log(props?.incentivee, 'trigger')
        if (shiftamount) {
            const totalval = (props?.incentive ? parseFloat(props?.incentive) : 0) + parseFloat(shiftamount);
            if (totalval) {
                setTotal(totalval)
            }

        }
    }, [shiftamount, props?.incentive])
    useEffect(() => {
        if (props?.JobEncounterOccurreneUpdateList?.length) {
            const sum = props?.JobEncounterOccurreneUpdateList?.reduce((a, { billingRate }) => a + billingRate, 0);
            setBillingRate(Number(sum)?.toFixed(2));
            dispatch(updateBillingRate(Number(sum)?.toFixed(2)));
        }
    }, [props?.JobEncounterOccurreneUpdateList])
    useEffect(() => {
        if (parseInt(props?.recursionFlag) === 2) {
            const totalval = (props?.incentive ? parseFloat(props?.incentive) : 0) +
                parseFloat(billingRate);
            setTotal(Number(totalval)?.toFixed(2));
            dispatch(updateJobInfoDetails(``, "total", Number(totalval)?.toFixed(2)));
        }
    }, [billingRate, props?.incentive, parseInt(props?.recursionFlag) === 2])

    useEffect(() => {
        //console.log(JobEncounterOccurreneUpdateList);
        const amount = {};
        const details = []
        JobEncounterOccurreneUpdateList.forEach((item) => {
            if (amount.hasOwnProperty(item.candidateUniqueId)) {
                amount[item.candidateUniqueId]?.push(item);
            } else {
                amount[item.candidateUniqueId] = [item];
            }
        });

        for (let key in amount) {
            // console.log(amount[key]);
            let value = [];
            if (amount[key]) {
                amount[key].map(item => {
                    const index = value.findIndex(el => el.shiftDate === moment(item.Start).format("MM/DD/YYYY"));
                    if (index < 0) {
                        value.push({ id: key, shiftDate: moment(item.Start).format("MM/DD/YYYY"), date: item.Start, shiftamount: item.billingRate, incentive: item?.incentive ? item?.incentive : '', total: Number((item.incentive ? parseFloat(item.incentive) : 0) + parseFloat(item.billingRate)).toFixed(2) });
                    } else {
                        value[index].shiftamount += item.billingRate ? item.billingRate : 0;
                        value[index].total = Number((value[index].incentive ? parseFloat(value[index].incentive) : 0) + parseFloat(value[index].shiftamount)).toFixed(2)
                    }
                })
            }
            // console.log(value, '------------new');
            details.push(...value)
        }

        if (details?.length > 0) {
            if (encounterCalculation?.length === 0) {
                const candidateUniqueId = [...new Set(details.map(item => item.id))]
                dispatch(setencounterCalculation(candidateUniqueId.map(item => { return { candidateUniqueId: item, shiftinfo: details.filter(val => val.id === item) } })));
            } else {
                const candidateUniqueId = [...new Set(details.map(item => item.id))]
                const newVal = JSON.parse(JSON.stringify(encounterCalculation));
                newVal.forEach(item => {
                    item.shiftinfo.forEach(item2 => {
                        const index = details.findIndex(val => item.candidateUniqueId === val.id && item2.shiftDate === val.shiftDate);
                        const filter = details.filter(val => item.candidateUniqueId === val.id && item2.shiftDate === val.shiftDate)
                            .map(val2 => { return { ...val2, incentive: item2.incentive, total: Number((item2.incentive ? parseFloat(item2.incentive) : 0) + parseFloat(val2.shiftamount)).toFixed(2) } });
                        if (index !== -1) {
                            details.splice(index, 1, ...filter);
                        }
                    })
                })
                dispatch(setencounterCalculation(candidateUniqueId.map(item => { return { candidateUniqueId: item, shiftinfo: details.filter(val => val.id === item) } })));
            }
        }
    }, [JobEncounterOccurreneUpdateList])
    useEffect(() => {
        if (config.baseUrl ) {
          let shiftDayFormat = ""
          if(parseInt(recursionFlag) !== 2 && shift?.date && shift?.startTime?.id){
            const shiftDay= moment(shift?.date + "" + shift?.startTime?.id, "YYYY-MM-DD hh:mm:ss");
            shiftDayFormat = `${moment(shiftDay).format('YYYY-MM-DDTHH:mm:ss')}Z`
          } else if (parseInt(recursionFlag) === 2 && JobEncounterOccurreneUpdateList?.length){
            const copyEncounterOccurrenceList = [...JobEncounterOccurreneUpdateList];
            const sortBasedonDate = copyEncounterOccurrenceList?.sort((a,b) => new Date(a?.Start) - new Date(b?.Start))
            shiftDayFormat = sortBasedonDate && `${moment(sortBasedonDate?.[0]?.Start).format("YYYY-MM-DDTHH:mm:ss")}Z`
          }
        //   console.log({shiftDayFormat});
          if(shiftDayFormat && location?.locationNameInfo?.id && jobInfo?.jobCategory?.id){
            const IncentiveMarkupParams = {
              locationId: location?.locationNameInfo?.id,
              jobCategoryId: jobInfo?.jobCategory?.id,
              shiftDate:shiftDayFormat
            }
            dispatch(getIncentiveMarkup(`${config.baseUrl}`, IncentiveMarkupParams, parseInt(recursionFlag)));
          }
        }
      }, [config, location?.locationNameInfo?.id, jobInfo?.jobCategory?.id, recursionFlag,shift?.date,shift?.startTime?.id,JobEncounterOccurreneUpdateList?.length])
    // get Incentive Markup
    // useEffect(() => {
    //     if (config.baseUrl && location?.locationNameInfo?.id && jobInfo?.jobCategory?.id) {
    //         const IncentiveMarkupParams = {
    //             locationId: location?.locationNameInfo?.id,
    //             jobCategoryId: jobInfo?.jobCategory?.id
    //         }
    //         dispatch(getIncentiveMarkup(`${config.baseUrl}`, IncentiveMarkupParams, parseInt(recursionFlag)));
    //     }
    // }, [config, location?.locationNameInfo?.id, jobInfo?.jobCategory?.id, recursionFlag])
    useEffect(() => {
        if(jobMultishiftOccurreneUpdateList?.length === 0) {
          dispatch(totalShiftAmountCalculation())
        }
      },[jobMultishiftOccurreneUpdateList?.length])
    const getAuthUserName = (id) => {
        const user = authUsersList.filter(item => item.value.toLowerCase() === id.toLowerCase());
        if (user?.length > 0) {
            return user[0]?.label
        } else {
            return ''
        }
    }
    // useEffect(() => {
    //     if (!props.editMode && props?.hourlyBillingRateToDisplay === "Variable" && config.baseUrl && (props?.jobSummeryJobsShifts !== 2)  && props?.jobCategoryId && props?.startTime && props?.endTime && (props?.currentShiftDate || props?.jobDateToDisplay) && props?.locationId) {
    //       const params = {
    //         locationId: props?.employerJobLocationsList ? props?.employerJobLocationsList[0]?.locationId : "",
    //         jobCategoryId: props?.jobCategoryId,
    //         startTime:  props?.startTime,
    //         endTime: props?.endTime,
    //         shiftDate: props?.currentShiftDate ?  props?.currentShiftDate :  props?.jobDateToDisplay
    //       };
    //       config.baseUrl &&
    //         dispatch(getViewVariableRateDetails({ url: config.baseUrl, params }));
    //     }
    //   }, [config.baseUrl,props.editMode, props?.hourlyBillingRateToDisplay ,props?.jobCategoryId, props?.startTime, props?.endTime, props?.currentShiftDate,props?.jobDateToDisplay, props?.locationId ]);

    const payRates = (
        <Popover id="popover-basic">
            <Popover.Body>
                <table className="table table-responsive">
                    <thead>
                        <tr>
                            <th className="text-capitalize">Start Time</th>
                            <th className="text-capitalize">End Time</th>
                            <th className="text-capitalize">Candidate Rate</th>
                            <th className="text-capitalize">Billing Rate</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            viewVariableRate?.viewPayRate?.map((item, index) => {
                                return (
                                    <tr className="border-bottom mt-2 bg-white">
                                        <td>{moment(item?.shiftStartTime, "hh:mm").format("hh:mm A")}</td>
                                        <td>{moment(item?.shiftEndTIme, "hh:mm").format("hh:mm A")}</td>
                                        <td>{item?.hourlyPayRate}</td>
                                        <td>{item?.totalRate}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </Popover.Body>
        </Popover>
    )

    return (
        <div className="col-md-12 col-xl-12">
            <div className="card">
                {
                    showModal && <Modal label={"Job Info"} showHide={edit} saveFunction={save}>
                        <JobInfo errors={props.errors} />
                    </Modal>
                }
                <div className="col-lg-12 col-md-12">
                    <div className="row">
                        <div className="card-header">
                            <b><h5 className="mb-0">Job Info</h5></b>
                            {
                                props.editMode && <a className="edit-icon" id="btnShowModel_Job_Type" href="#" onClick={edit}>
                                    <i className="fe fe-edit" title="Edit Job Info"></i>
                                </a>
                            }
                        </div>
                    </div>
                </div>
                <div className="card-body ">
                    <div className="row">
                        {props.editMode && parseInt(props?.recursionFlag) === 2 ? <>
                            <div className="col-12">
                                <div className="row">
                                    <div className="d-flex border-bottom">
                                        <p className="col-2 fw-bold  d-flex align-items-center justify-content-center">Candidate Name</p>
                                        <p className="col-10 d-flex align-items-center justify-content-between">
                                            <span className="col-2  fw-bold d-flex align-items-center justify-content-center">Date</span>
                                            <span className="col-2 fw-bold d-flex align-items-center justify-content-center">Encounter Rate</span>
                                            <span className="col-2  fw-bold d-flex align-items-center justify-content-center">Incentive</span>
                                            <span className="col-2  fw-bold d-flex align-items-center justify-content-center">Incentive Amount</span>
                                            <span className="col-2 fw-bold d-flex align-items-center justify-content-center">Total Billing Amount</span>
                                        </p>

                                    </div>
                                </div>
                                <div className="row">
                                    {
                                        encounterCalculation.map((item, index) => {
                                            return <div className=" d-flex border-bottom">
                                                <span className="col-2 h-full d-flex align-items-center justify-content-center"> {getAuthUserName(item?.candidateUniqueId)}</span>
                                                <div className="col-10">
                                                    {
                                                        item.shiftinfo.map(sub => {

                                                            return <>
                                                                <p className="d-flex align-items-center justify-content-between m-0 py-2">
                                                                    <span className="col-2 d-flex align-items-center justify-content-center  h-full">{sub.shiftDate}</span>
                                                                    <span className="col-2 d-flex align-items-center justify-content-center h-full">{`$ `}{parseFloat(sub.shiftamount).toFixed(2)}</span>
                                                                    <span className="col-2 d-flex align-items-center justify-content-center h-full">{sub.incentive ? `$ ${formatNumberWithCommas(sub.incentive)}`:''}</span>
                                                                    <span className="col-2 d-flex align-items-center justify-content-center h-full">{`$ `} {formatNumberWithCommas(Math.round((parseFloat(sub?.incentive * incentiveMarkup) + Number.EPSILON) * 100) / 100) ?? ""}</span>
                                                                    <span className="col-2 d-flex align-items-center justify-content-center h-full">{`$ `} {formatNumberWithCommas((Number(sub?.shiftamount ? sub?.shiftamount : 0) + ((parseFloat(sub?.incentive ? sub?.incentive : 0)) * (incentiveMarkup ? incentiveMarkup : 0))).toFixed(2)) ?? ""}</span>
                                                                </p>
                                                            </>
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        </> :
                            <>
                                {/* <div className="col-lg-4 col-md-4">
                            <label className="form-label">Shift Template</label>
                            <label htmlFor="Location Name">{props?.jobTemplateName}</label>
                        </div> */}
                                <div className="col-lg-3 col-md-3">
                                    <label className="form-label">Shift Title</label>
                                    <label htmlFor="City">{props.jobTitle}</label>
                                </div>
                                <div className="col-lg-3 col-md-3">
                                    <label className="form-label">Shift descriptions</label>
                                    <label dangerouslySetInnerHTML={{ __html: props?.editMode ? jobInfo?.jobDescription : props?.jobDescription }}></label>
                                </div>
                                {
                                    !props.editMode &&         
                                    <>
                                     <div className="col-lg-3 col-md-3">
                                             <label className="form-label">Billing Rate</label>
                                             {props?.claimedCandidateInfo?.isClaimed && <label htmlFor="billingrate">{props?.hourlyBillingRateToDisplay === "Variable" ? "" : '$'}{props?.hourlyBillingRateToDisplay}</label>}
                                             
                                    </div>
                                    <div className="col-lg-3 col-md-3">
                                        <label className="form-label">Shift Amount</label>
                                        {props?.claimedCandidateInfo?.isClaimed &&<label htmlFor="shiftamount">{props?.shiftAmountToDisplay}</label>}
                                        
                                    </div>
                                    </>
                                }
                                {/* <div className="col-lg-3 col-md-3">
                                    <label className="form-label">Billing Rate</label> */}
                                {/* {props.editMode ? parseInt(props?.recursionFlag) === 2 ? <label htmlFor="City">{billingRate}</label>: parseInt(props?.recursionFlag) === 1 ?  <label htmlFor="City">{props?.billingrate}</label>: <label htmlFor="City">${props?.billingrate}</label>  : <label htmlFor="billingrate">{props?.hourlyBillingRateToDisplay}</label>  } */}
                                {/* {props.editMode ? <label htmlFor="billingrate">{props?.billingrate === "Variable" ? "" : '$'}{parseInt(props?.recursionFlag) !== 2 ? props?.billingrate : billingRate}</label>  */}
                                {/* : <label htmlFor="billingrate">{props?.hourlyBillingRateToDisplay === "Variable" ? "" : '$'}{props?.hourlyBillingRateToDisplay}</label>} */}
                                {/* <label htmlFor="City">{props.billingrate}</label> */}
                                {/* </div> */}
                                {/* {
                                   (!props.editMode && props?.hourlyBillingRateToDisplay === "Variable") ? 
                                    <div className="col-lg-3 col-md-3">
                                        <label className="form-label">Pay Rate</label>
                                            <OverlayTrigger
                                                placement="top"
                                                delay={{ show: 250, hide: 400 }}
                                                overlay={payRates}
                                                >
                                                <i class="fa fa-question-circle" style={{ fontSize: "15px", marginTop: "4px", cursor: "pointer" }} aria-hidden="true"></i>
                                            </OverlayTrigger>
                                </div>: <div className="col-lg-3 col-md-3"></div>
                                } */}

                                {/* {parseInt(props?.recursionFlag) !== 2 && <> <div className="col-lg-4 col-md-4">
                                    <label className="form-label">Shift Amount</label>
                                    {props.editMode ? <label htmlFor="shiftamount">${props.shiftamount ? props.shiftamount : shiftamount}</label> : <label htmlFor="shiftamount">{props?.shiftAmountToDisplay}</label>}

                                </div></>} */}
                                {/* <div className="col-lg-3 col-md-3">
                                    <label className="form-label">Shift Amount</label>
                                    {props.editMode ? <label htmlFor="shiftamount">${props.shiftamount ? props.shiftamount : shiftamount}</label> : <label htmlFor="shiftamount">{props?.shiftAmountToDisplay}</label>}

                                </div> */}

                                <div className="col-lg-3 col-md-3">
                               { parseInt(props?.recursionFlag) !== 3 && <>
                                    <label className="form-label">Incentive</label>
                                    <label htmlFor="City">
                                      { props?.incentive ? ` $ ${formatNumberWithCommas(props.incentive)}`:""}
                                    </label>
                               </>  }
                                </div>
                                <div className="col-lg-3 col-md-3">
                                { parseInt(props?.recursionFlag) !== 3 && <>
                                    <label className="form-label">Incentive Billing Amount</label>
                                    {props.editMode ? <label htmlFor="shiftamount"> {props.incentive ?
                                        `$ ${formatNumberWithCommas(Math.round((parseFloat(props.incentive * incentiveMarkup) + Number.EPSILON) * 100) / 100) ?? ""}`
                                        : props.incentive}</label> : <label htmlFor="shiftamount">
                                        {parseInt(props?.recursionFlag) === 3 ? "" : props?.employerIncentiveToDisplay}
                                    </label>}
                                </> }
                                    {/* <label htmlFor="City">{parseFloat(props.incentive * incentiveMarkup).toFixed(2)}</label> */}
                                </div>
                                {
                                    !props?.editMode && 
                                    <div className="col-lg-3 col-md-3">
                                        <label className="form-label">  Total Billing Amount</label>
                                       {props?.claimedCandidateInfo?.isClaimed  &&
                                         <label htmlFor="total">
                                         {props?.totalShiftAmountToDisplay}
                                         </label>
                                       }
                                    </div>
                                }
                                {/* <div className="col-lg-3 col-md-3">
                                    <label className="form-label">  Total Billing Amount</label>
                                    {props.editMode ? <label htmlFor="total">${parseInt(props?.recursionFlag) !== 2 ? 
                                    props?.total 
                                    ? 
                                    (props?.recursionFlag === 3 ? props?.total : 
                                       ((Number(props?.shiftamount ? props?.shiftamount : 0) + ((parseFloat(props?.incentive ? props?.incentive : 0)) * (incentiveMarkup ? incentiveMarkup : 0))).toFixed(2))
                                    )
                                    // props?.total 
                                    : 
                                    total 
                                    : 
                                    total
                                    }</label> 
                                    : <label htmlFor="total">
                                        {props?.totalShiftAmountToDisplay}
                                        </label>} */}
                                {/* <label htmlFor="City">{props.total ? props.total : total}</label> */}
                                {/* </div> */}
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
